import { app } from "@microsoft/teams-js";
import { Suspense, lazy, useEffect, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppRoutes, TeamsRoutes } from "./components/routes/route.path";
import AppAlertComponent from "./components/shared/app-alert/app-alert.component";
import useOnlineStatus from "./hooks/useOnlineStatus";
import useWindowResize from "./hooks/useWindowResize";
import { PlanMetrics } from "./models/plan-metrics.model";
import * as selector from './selectors/selectors';
import FallbackUI from "./components/shared/fallback-ui/fallback-page.component";
import { ChannelUserService } from "./services/ChannelUserService";
import LiveChatShareToChatLinkComponent from "./components/live-chat/live-chat-share-to-chat-link-component";
import { ChannelAuthService } from "./services/ChannelAuthService";
import { getChanelAuthorisedRoutes, getUnAuthorisedRoutes } from "./components/routes/channel-rouths.config";
import PageNotFound from './components/shared/page-not-found-component'
import LiveChatPopUpComponent from './components/live-chat/live-chat-popup-component'

const Layout = lazy(() => import('./components/layout/channel-layout.component'))

interface ITeamsProps { }

const TeamsApp = (props: ITeamsProps) => {
    const { showAlert, alertType, alertText, closeAlert } = useOnlineStatus();
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics);
    const userRole: number = useSelector(selector.loggedInUserroleId);
    useWindowResize();

    // useLayoutEffect(() => {
    //     const isUnAuthRoute = getUnAuthorisedRoutesTeams().filter(x => x.Path.includes(window.location.pathname)).length > 0;
    //     if (!AuthService.isUserLoggedIn() && !isUnAuthRoute) {
    //         AuthService.logout();
    //     }
    // }, [])


    useEffect(() => {
        app.initialize().then((context) => {
            app.notifySuccess();
        }).catch(err => {
            window.location.replace("/channels/sign-in")
        });

        app.getContext().then((context) => {
            console.log('Teams context:', context.user.userPrincipalName);
            localStorage.setItem("teamsUserEmail", context.user.userPrincipalName)
        });
    }, []);

    return (
        <>
            {showAlert && (
                <AppAlertComponent
                    OnClose={closeAlert}
                    TextProps={() => <span>{alertText}</span>}
                    Type={alertType}
                    ShowAlert={showAlert}
                />
            )}
            <BrowserRouter>
                <Routes>
                    {/** Public Routes */}
                    {getUnAuthorisedRoutes().map(route => <Route key={route.id} path={route.path} Component={route.component} />)}

                    {/** Protected Routes */}
                    <Route path={TeamsRoutes.HOME_PATH} element={<Suspense fallback={<FallbackUI />}><Layout /></Suspense>}>
                        {
                            getChanelAuthorisedRoutes(userRole).map(route => route.hasSubRoutes ? route.children?.map(croute => <Route index key={croute.id} path={croute.path} Component={croute.component} />) : <Route index key={route.id} path={route.path} Component={route.component} />)
                        }
                        <Route path="*" element={<PageNotFound />} />
                    </Route>
                    <Route index path={AppRoutes.HOME_PATH} element={<Navigate replace to={!!ChannelAuthService.isUserLoggedIn() ? ChannelUserService.hasSysAdminRole() ? AppRoutes.CHANNELS_ORGANISATIONS : AppRoutes.CHANNELS_DASHBOARD : AppRoutes.CHANNELS_SIGN_IN} />} />

                    {/* <Route path={AppRoutes.LIVE_CHAT} element={<LiveChatPopUpComponent />} /> */}

                    {/* <Route path={AppRoutes.SHARE_TO_CHAT_LINK} element={<LiveChatShareToChatLinkComponent />} /> */}
                </Routes>
            </BrowserRouter>
        </>
    )
}

export default TeamsApp